/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Office_ModelInputs */

const cs_office_model = /** @type {(inputs: Office_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model organizace`)
};

const en_office_model = /** @type {(inputs: Office_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization model`)
};

/**
* | output |
* | --- |
* | "Organization model" |
*
* @param {Office_ModelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const office_model = /** @type {((inputs?: Office_ModelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Office_ModelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_office_model(inputs)
	return cs_office_model(inputs)
});